<template>
    <div class="dam-profile-card">
        <h5 class="card-detail-heading">{{$t('dam-profile.meteorological-forecast')}}</h5>
        <div class="card-detail-text mt-2 pb-4 text-center">
            <span>{{$t('dam-profile.for')}}</span>
            <span>{{'&nbsp;'}}</span>
            <span>{{lastUpdatedDate}}</span>
            <span>{{'&nbsp;'}}</span>
            <span>{{$t('dashboard.year')}}</span>
            <span v-if="this.$i18n.locale === 'bg'">.</span>
        </div>
        <div class="d-flex justify-content-center align-items-center">
            <div class="d-flex">
                <span class="temp-value">{{temperature}}</span>
                <span class="temp-unit"> °C</span>
            </div>
            <ForecastIcon
                :statuss-code="statussCode"
                :time-part-of-day="timePartOfDay"
            />
        </div>
        <div class="powered-by-credit text-right mt-3">Powered by <a href="https://www.weatherapi.com/" title="Weather API">WeatherAPI.com</a></div>
    </div>
</template>

<script>
    // utils
    import {formatShortDateCard, parsedDate} from "../../utils/common";
    import apiCall from "../../utils/api";
    // external
    import {mapGetters, mapActions} from "vuex";
    import {AUTH_LOGOUT} from "../../store/actions/auth";
    // components
    import ForecastIcon from "./ForecastIcon.vue";

    export default {
        name: 'ProfileDamMeteorologicalForecast',
        components: {
            ForecastIcon
        },
        data() {
            return {
                statussCode: "",
                timePartOfDay: "",
                temperature: "",
                lastUpdatedTime: "",
                lastUpdatedDate: ""
            }
        },
        computed: {
            ...mapGetters(["currentDamSelectedCoordinates"])
        },
        async mounted() {
            await this.dispatchForecast();
        },
        methods: {
            ...mapActions([AUTH_LOGOUT]),
            async dispatchForecast() {
                const [lat, long] = this.currentDamSelectedCoordinates;
                try {
                    const {data} = await apiCall.getWeatherForecast({lat, long});
                    if (data && 'current' in data && 'last_updated' in data.current) {
                        const lastUpdated = parsedDate(data.current.last_updated);
                        // Gets the img data from url Ex. //cdn.weatherapi.com/weather/64x64/night/116.png
                        const imgUrl = data.current.condition.icon.split('/').reverse();
                        const [img, timePartOfDay] = imgUrl;
                        ([this.statussCode] = img.split('.'));
                        this.timePartOfDay = timePartOfDay;

                        this.temperature = data.current.temp_c;
                        this.lastUpdatedTime = formatShortDateCard(lastUpdated)[0];
                        this.lastUpdatedDate = formatShortDateCard(lastUpdated)[1];
                    }
                } catch (error) {
                    this.error = true;
                    console.log(error);
                    if (error.request.status === 401) {
                        // if resp is unauthorized, logout
                        this.AUTH_LOGOUT();
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "src/assets/scss/_variables";
    @import "src/assets/scss/_cardDetail";

    .temp {
        &-value,
        &-unit {
            color: $menuBlue;
        }

        &-value {
            font-size: 25px;
        }
        &-unit {
            font-weight: 700;
        }

        @media (min-width: 992px){
            &-value {
                font-size: 47px;
            }
        }
    }

    .powered-by-credit {
        font-size: $font-size-v-sm;
    }
</style>